exports.default = {
  'terms_title': '服務條款',
  'privacy_title': '隱私政策',
  'back': '返回',
  'back_home': '返回首頁',
  'document_navigation': '法律文件',
  'start_using': '開始使用'
}
